import { ButtonColors } from "@models/enums/components/Button/ButtonColor.enum";
import { GroupAssignedAmenity } from "../amenities/AmenityGroupAssigned.interface";
import { MenuTypes } from "@models/enums/components/Menu/MenuTypes.enum";
import { MenuModes } from "@models/enums/components/Menu/MenuModes.enum";
import { Filter } from "@models/types/app/Filter.type";
	
export interface MenuConfiguration {
    clientId:      string;
    type:          DisplayType
    isLegend:      boolean;
    menus:         Record<MenuKeys, Menu | undefined>;
}

export type MenuKeys = 'regular' | 'premium' | 'suites';

export enum DisplayType {
  Simple = 'simple',
  Advanced = 'advanced'
}

export interface Menu {
    id:             MenuKeys;
    label:          string; 
    buttonType?:    ButtonColors;
    order:          number;
    isVisible:      boolean;
    content:        MenuContent[];
}

export interface MenuContent {
    amsId?:         number;
    data:           MenuContentItem;
}

export interface MenuContentItem extends Omit<Partial<GroupAssignedAmenity>, 'id' | 'relatedSeats'> {
    id:             string | number;
    type:           MenuTypes;
    mode:           MenuModes;
    mapId?:         string;
    venueId?:       string;
    is3dView?:      boolean;
    viewId?:        string;
    title?:         string;
    relatedSeats?:  Filter;
    children?:      MenuContent[];
}
